module.exports = __webpack_public_path__ + "static/img/13.f1f01ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/13.png
// module id = 7vnh
// module chunks = 0